<nb-layout>
    <nb-layout-column center>
        <nb-card>
            <nb-card-header center class="fond">
                <h3 class="text-white">{{ 'WISHES.TITLE' | translate }}</h3>
            </nb-card-header>
            <nb-card-body>
                <h5 class="text-center">{{ 'WISHES.SUBTITLE' | translate }}</h5>
                <p class="text-center">{{ 'WISHES.REQUIRED_FIELD' | translate }} : <b class="obli">*</b></p>

                <form [formGroup]="secondForm" 
                      #desirForm="ngForm" 
                      (ngSubmit)="onSubmitDesir($event.target.value)" 
                      class="step-container">
                    
                    <!-- Catégorie et Sous-catégorie -->
                    <nb-form-field>
                        <div class="row">
                            <div class="col-md-5 col-sm-12">
                                <div class="input-group mb-4">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">
                                            <nb-icon icon="briefcase-outline" [options]="{ animation: { type: 'zoom' } }"></nb-icon>
                                            <b class="obli">*</b>
                                        </span>
                                    </div>
                                    <nb-select placeholder="{{ 'WISHES.SELECT_CATEGORY' | translate }}"
                                             formControlName="idcategorie"
                                             class="form-control"
                                             [ngModel]="idcategorie"
                                             (selectedChange)="selectType($event)"
                                             appearance="filled"
                                             size="large"
                                             [ngClass]="{ 'is-invalid': submitted && f1.idcategorie.errors }"
                                             required>
                                        <nb-option *ngFor="let cat of Categories"
                                                  [value]="cat.idcategorie">
                                            {{gData.getTranslatedCategoryName(cat.nomcategorie)}}
                                        </nb-option>
                                    </nb-select>
                                </div>
                            </div>
                            <div class="col-md-2"></div>
                            <div class="col-md-5 col-sm-12">
                                <div class="input-group mb-4">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">
                                            <nb-icon icon="briefcase-outline" [options]="{ animation: { type: 'zoom' } }"></nb-icon>
                                            <b class="obli">*</b>
                                        </span>
                                    </div>
                                    <nb-select placeholder="{{ 'WISHES.SELECT_SUBCATEGORY' | translate }}"
                                             formControlName="idtypelogement"
                                             [ngModel]="idtypelogement"
                                             class="form-control"
                                             (selectedChange)="selectSubcat($event)"
                                             appearance="hero"
                                             size="large"
                                             [ngClass]="{ 'is-invalid': submitted && f1.idtypelogement.errors }"
                                             required>
                                        <nb-option *ngFor="let type of Typelogements"
                                                  [value]="type.idtypelogement">
                                            {{ gData.getTranslatedPropertyType(type.nomtypelogement)}}
                                        </nb-option>
                                    </nb-select>
                                </div>
                            </div>
                        </div>
                    </nb-form-field>

                    <hr>

                    <!-- Ville et Quartiers -->
                    <nb-form-field>
                        <div class="row">
                            <div class="col-md-5 col-sm-12">
                                <div class="input-group mb-4">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">
                                            <nb-icon icon="pantone-outline" [options]="{ animation: { type: 'zoom' } }"></nb-icon>
                                            <b class="obli">*</b>
                                        </span>
                                    </div>
                                    <nb-select placeholder="{{ 'WISHES.SELECT_CITY' | translate }}"
                                             formControlName="idville"
                                             class="form-control"
                                             [ngModel]="idville"
                                             (selectedChange)="selectVille($event)"
                                             appearance="hero"
                                             size="large"
                                             [ngClass]="{ 'is-invalid': submitted && f1.idville.errors }"
                                             required>
                                        <nb-option *ngFor="let v of Villes"
                                                  [value]="v.idville">
                                            {{v.nomville}}
                                        </nb-option>
                                    </nb-select>
                                </div>
                            </div>
                            <div class="col-md-2"></div>
                            <div class="col-md-5 col-sm-12">
                                <div class="input-group mb-4">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">
                                            <nb-icon icon="pantone-outline" [options]="{ animation: { type: 'zoom' } }"></nb-icon>
                                            <b class="obli">*</b>
                                        </span>
                                    </div>
                                    <nb-select multiple
                                             placeholder="{{ 'WISHES.SELECT_DISTRICTS' | translate }}"
                                             formControlName="idquartier"
                                             [formControl]="secondForm.controls['idquartier']"
                                             class="form-control"
                                             [ngModel]="idquartier"
                                             (selectedChange)="selectQuartier($event)"
                                             appearance="hero"
                                             size="large"
                                             [ngClass]="{ 'is-invalid': submitted && f1.idquartier.errors }"
                                             required>
                                        <nb-option *ngFor="let qt of Quartiers"
                                                  [value]="qt.idquartier">
                                            {{qt.nomquartier}}
                                        </nb-option>
                                    </nb-select>
                                </div>
                            </div>
                        </div>
                    </nb-form-field>

                    <hr>

                    <!-- Type de contrat -->
                    <nb-form-field>
                        <div class="row">
                            <div class="col-md-3 col-sm-12">
                                <div class="input-group mb-4">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">
                                            <nb-icon icon="brush-outline" [options]="{ animation: { type: 'zoom' } }"></nb-icon>
                                            <b class="obli">*</b>
                                        </span>
                                    </div>
                                    <nb-select placeholder="{{ 'WISHES.SELECT_CONTRACT' | translate }}"
                                             formControlName="typecontrat"
                                             class="form-control"
                                             [ngModel]="typecontrat"
                                             (selectedChange)="selectTypeContrat($event)"
                                             appearance="hero"
                                             size="large"
                                             [ngClass]="{ 'is-invalid': submitted && f1.typecontrat.errors }"
                                             required>
                                        <nb-option value="A vendre">{{ 'WISHES.FOR_SALE' | translate }}</nb-option>
                                        <nb-option value="A louer">{{ 'WISHES.FOR_RENT' | translate }}</nb-option>
                                    </nb-select>
                                </div>
                            </div>
                        </div>
                    </nb-form-field>

                    <hr>

                    <!-- Sliders -->
                    <div class="second-row">
                        <!-- Distance -->
                        <div class="price-range-wrap mb-4">
                            <div class="price-text">
                                <label for="distanceRange">
                                    {{ 'WISHES.DISTANCE_FROM_ROAD' | translate }}: [{{mindist}}-{{maxdist}}] {{ 'WISHES.DISTANCE_UNIT' | translate }}
                                </label>
                                <ng5-slider [(value)]="mindist"
                                          [(highValue)]="maxdist"
                                          [options]="optionsdist">
                                </ng5-slider>
                            </div>
                        </div>

                        <!-- Prix -->
                        <div class="price-range-wrap mb-4">
                            <div class="price-text">
                                <label for="priceRange">
                                    {{ 'WISHES.PRICE_RANGE' | translate }}: [{{minValueprix}}-{{maxValueprix}}] {{ 'WISHES.PRICE_UNIT' | translate }}
                                </label>
                                <ng5-slider [(value)]="minValueprix"
                                          [(highValue)]="maxValueprix"
                                          [options]="optionsprix">
                                </ng5-slider>
                            </div>
                        </div>

                        <!-- Superficie -->
                        <div class="price-range-wrap mb-4">
                            <div class="price-text">
                                <label for="areaRange">
                                    {{ 'WISHES.AREA' | translate }}: [{{minValuesup}}-{{maxValuesup}}] {{ 'WISHES.AREA_UNIT' | translate }}
                                </label>
                                <ng5-slider [(value)]="minValuesup"
                                          [(highValue)]="maxValuesup"
                                          [options]="optionssup">
                                </ng5-slider>
                            </div>
                        </div>
                    </div>

                    <!-- Boutons -->
                    <div class="row mt-4">
                        <div class="col-md-4">
                            <button nbButton
                                    shape="semi-round"
                                    outline
                                    status="danger"
                                    class="w-100">
                                {{ 'WISHES.CANCEL' | translate }}
                            </button>
                        </div>
                        <div class="col-md-4"></div>
                        <div class="col-md-4">
                            <button nbButton
                                    type="submit"
                                    [disabled]="!desirForm.form.valid"
                                    shape="semi-round"
                                    outline
                                    status="success"
                                    class="w-100">
                                {{ 'WISHES.SUBMIT' | translate }}
                            </button>
                        </div>
                    </div>
                </form>
            </nb-card-body>
        </nb-card>
    </nb-layout-column>
    <nb-layout-column rigth class="colored-column-info"></nb-layout-column>
    <nb-layout-column left class=""></nb-layout-column>
  </nb-layout>
